module.exports = __webpack_public_path__ + "static/img/pdf_icon.11a962ee.jpg";